module.exports = __webpack_public_path__ + "img/stop_btn.8ea9dbef.png";